import React from "react";
import { RegisterForm } from "./RegisterForm";

export function Register() {
  const [openModal, setopenModal] = React.useState(null);

  const handleOpenModal = (row) => {
    setopenModal(true);
  };

  const handleCloseModal = () => {
    setopenModal(false);
  };

  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head">
            <h3 className="account__title">Crea una cuenta</h3>
          </div>
          <RegisterForm
            openModal={openModal}
            handleCloseModal={handleCloseModal}
          />
        </div>
      </div>
    </div>
  );
}
